import { VOUCHERBATCH_STATUSES } from 'app/core/constants'

/**
 * Directive for change status batch.
 *
 * @class batchProgress
 * @memberof mwApp/partners
 * @see mwApp/partners
 *
 * @ngdoc directive
 * @name mwApp/partners:batchProgress
 *
 * @example
 * <batch-progress></batch-progress>
 */
/* @ngInject */
export function batchProgress ($interval) {
  return {
    restrict: 'E',
    template: /* html */ `<i aria-hidden="true"></i>`,
    replace: true,
    link: function (scope, element) {
      let forbiddenStatuses = [
        'UPDATING',
        'CREATING'
      ]
      let interval

      scope.$on('$locationChangeSuccess', function () {
        $interval.cancel(interval)
      })

      scope.$watch('batch.progress', function () {
        managedStatus()
      }, true)

      /* init sub methods */
      function managedStatus () {
        if (interval) {
          $interval.cancel(interval)
        }

        if (!checkStatus(scope.batch.progress)) {
          element.removeAttr('class')
          element.addClass('fa fa-spinner fa-spin custom-text-warning')
          element.next('<small>').remove()
          element.after(`&nbsp;<small>${VOUCHERBATCH_STATUSES[scope.batch.progress]}...</small>`)

          interval = $interval(function () {
            scope.batch._getProgressState()
              .then(statusResponse => {
                if (checkStatus(statusResponse)) {
                  $interval.cancel(interval)
                  scope.batch.progress = statusResponse
                }
              })
          }, 5000)
        } else {
          setStatus(scope.batch.progress)
        }
      }

      function setStatus (status) {
        element.removeAttr('class')
        element.next('<small>').remove()

        switch (status) {
          case 'DONE':
            element.addClass('fa fa-check-circle text-success')
            element.after(`&nbsp;<small>${VOUCHERBATCH_STATUSES[status]}</small>`)
            break
          case 'DONE_WITH_ERRORS':
            element.addClass('fa fa-exclamation-circle custom-text-warning')
            element.after(`&nbsp;<small>${VOUCHERBATCH_STATUSES[status]}</small>`)
            break
          case 'FAILED':
            element.addClass('fa fa-times-circle text-warning')
            element.after(`&nbsp;<small>${VOUCHERBATCH_STATUSES[status]}</small>`)
            break
          case 'DELETING':
            element.addClass('fa fa-spinner fa-spin text-warning')
            element.after(`&nbsp;<small>${VOUCHERBATCH_STATUSES[status]}...</small>`)
            break
          default:
            element.addClass('fa fa-question-circle text-info')
            break
        }
      }

      function checkStatus (status) {
        return forbiddenStatuses.indexOf(status) === -1
      }
    }
  }
}
